import React from 'react'
import { useSelector } from 'react-redux'
import FlexContainer from 'core-system/FlexContainer'
import CheckmarkIcon from 'core-system/Icons/Actions/Checkmark'
import palette from 'core-system/Themes/palette'
import SummaryContainerBox from 'features/Programs/Summary/components/SummaryContainerBox'
import Coupon from 'core-system/Icons/Programs/Coupon'
import Text from 'core-system/Text'
import wordings from '../Shared/wordings.json'
import { couponType } from '../Shared/types'
import { AppState } from 'redux/config/store'
import ProgramUtils from 'core-system/Program/ProgramUtils'
import styled from 'styled-components'

const OptionsHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`

const Option = styled.div`
  padding: 0 0.5rem;
`

interface CouponSummaryProps {
  coupon: couponType
}

const CouponSummary = ({ coupon }: CouponSummaryProps) => {
  const merchantsMap = useSelector(
    (state: AppState) => state.programs.merchantsMap
  )
  const merchantId = coupon.merchantIds[0]
  const merchantName =
    coupon.availableMerchants.find((merchant) => merchant.id === merchantId)
      ?.name || merchantsMap?.[merchantId]?.name

  return (
    <SummaryContainerBox title={wordings.coupon.title}>
      <OptionsHeader>
        <Coupon color={palette.secondary.purple600} />
        <Text variant='action3' marginLeft='0.5rem'>
          Program Options
        </Text>
      </OptionsHeader>
      {coupon.merchantsEnabled && merchantId ? (
        <Option>
          <FlexContainer
            alignItems='center'
            justifyContent='space-between'
          >
            <Text
              variant='action3'
              textColor={palette.text.secondary}
              captionTitle
            >
              {ProgramUtils.optionsCopy.coupon.title}
            </Text>
            <CheckmarkIcon
              width={13}
              height={13}
              color={palette.secondary.purple600}
            />
          </FlexContainer>
          <Text variant='action4' marginTop='0.5rem'>
            {merchantName}
          </Text>
          {coupon.couponCode ? (
            <Text variant='action4' fontWeight='bold'>
              {coupon.couponCode}
            </Text>
          ) : null}
        </Option>
      ) : (
        <Text variant='body2' textColor={palette.text.secondary}>
          No options are selected for this program
        </Text>
      )}
    </SummaryContainerBox>
  )
}

export default CouponSummary
